<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="10" :sm="10">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'loanTime')">
              <a-range-picker
                v-model="queryParam.lendingTime"
                format="YYYY-MM-DD"
                style="width: 100%;"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'custType')">
              <a-select default-value="" style="width: 120px" v-model="queryParam.custType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="1">
                  New Customer
                </a-select-option>
                <a-select-option value="2">
                  Existing Customer
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'ProductType'">
              <a-select
                v-model="queryParam.appssid"
              >
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="'Order Type'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.orderType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="0">
                  Normal Order
                </a-select-option>
                <a-select-option value="1">
                  Extension Order
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('order.applicationDeadline')">
              <a-select default-value="" style="width: 190px" v-model="queryParam.deadlineConfigValue">
                <a-select-option v-for="item in deadlineConfigList" :key="item.itemValue">
                  {{ item.itemText }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <!-- <a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">Export</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :rowClassName="rowClassName"
        :pagination="false"
        :loading="loading"
        bordered>
      </a-table>


    </div>
    <v-modal
        v-model="visible"
        :title="$t('order.collectionDetail')">
        <div style="padding: 20px;">
            <collection-detail
              v-if="visible"
              :orderId="orderId"
              :custInfoId="custInfoId"
              :taskId="taskId"
              :auditDrawer="false"
              @close="visible = false;"/>
        </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {countPlatformLoanDataWithDate, getApplist} from '@/webpublicapi/order'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal';
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}

export default {
  name: 'CountCollectionTaskDispense',
  components: {
    Dict,
    DictSelect,
    vModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      appList: [],
      deadlineConfigList: [],
      // Query conditions
      queryParam: {
        "orderNo":"",
        "appssid":"",
        "mobileNo":"",
        "orderType":"",
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [

        {
          title:  'DisbursementDate',
          align: 'left',
          dataIndex: 'paymentTime'
        },
        {
          title: 'Disbursement Count',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: 'New Customer Transaction Count',
          align: 'left',
          dataIndex: 'newLoanCount'
        },
        {
          title: 'New Customer Per Item Average',
          align: 'left',
          dataIndex: 'jianjunNew'
        },
        {
          title: 'Old Customer Transaction Count',
          align: 'left',
          dataIndex: 'oldLoanCount'
        },
        {
          title: 'Old Customer Per Item Average',
          align: 'left',
          dataIndex: 'jianjunOld'
        },
        {
          title: 'Old Customer Proportion',
          align: 'left',
          dataIndex: 'noRate'
        },
        {
          title: 'DisbursementPrincipal',
          align: 'left',
          dataIndex: 'paymentAmt'
        },
        {
          title: 'New Customer Disbursement Principal',
          align: 'left',
          dataIndex: 'newPaymentAmt'
        },
        {
          title: 'Old Customer Disbursement Principal',
          align: 'left',
          dataIndex: 'oldPaymentAmt'
        },
        {
          title: 'Disbursement Contract Amount',
          align: 'left',
          dataIndex: 'applyAmt'
        },
        {
          title: 'New Customer Contract Amount',
          align: 'left',
          dataIndex: 'newApplyAmt'
        },
        {
          title: 'Old Customer Contract Amount',
          align: 'left',
          dataIndex: 'oldApplyAmt'
        }
      ]
    },
  },
  created () {
    getApplist().then(res => {
      this.appList = res.data || [];
    });
    this.getDict();
    this.loadData();
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || [];
    })
  },
  methods: {
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData()
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      countPlatformLoanDataWithDate(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          // this.total = res.data.total
          this.dataSource = res.data || [];
          if(this.dataSource.length > 0){
            for(var i = 0 ; i < this.dataSource.length ; i ++){
              var dataO = this.dataSource[i];

              dataO.jianjunOld = (dataO.oldApplyAmt / dataO.oldLoanCount).toFixed(1);
              dataO.jianjunNew = (dataO.newApplyAmt / dataO.newLoanCount).toFixed(1);

            }
          }
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { lendingTime } = this.queryParam;
      const data = {
          ...this.queryParam,
          lendingTimeStart: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[0]) : undefined,
          lendingTimeEnd : (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[1]) : undefined,
      }
      delete data.applyDate;
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.lendingTime = undefined;
      that.loadData(this.form.pageNum)
    },
    changeModal (visible) {
        this.visible = visible;
    },
    downLoadData (arg2) {
      var params = this.getQueryParams(arg2)// Query conditions
      const file = {
        fileUrl: '/api/web/platform/order/countLoanDataWithDateExcel?lendingTimeStart=' + params.lendingTimeStart + '&lendingTimeEnd=' + params.lendingTimeEnd + '&custType=' + params.custType,
        fileName: 'countLoanDataWithDateExcel.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    rowClassName(record,index){
      const date = new Date(record.paymentTime)
      let className= date.getDay() % 6 === 0 ? 'table_weekendColor' : ''
      return className;
    }

  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
